import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WindDirectionAttribute extends Sensor {
  public windDirectionChart: any;
  private windDirectionSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.windDirectionChart = null;
    this.windDirectionSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.windDirectionSensor, position);
      this.windDirectionSensor[position].push([timestamp, element.windDirection]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWindDirection = this.windDirectionSensor.filter(series => series.length > 0);

    const positionNodeWindDirection = this.windDirectionSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.windDirectionChart = this.getConfigChar(
      'windDirection',
      this.getChartSeriesNewNode('Sensor', filteredWindDirection, positionNodeWindDirection),
      this.getRanges('windDirection'),
      this.getLimits('windDirection')
    );
  }

  public hasWindDirectionSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.windDirectionSensor.length &&
      this.windDirectionSensor[index].length > 0
    );
  }

  public getWindDirectionSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.windDirectionSensor.length) {
      const sensorData = this.windDirectionSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Dirección del Viento ', value: 'windDirection' }
    ];
  }
}
